var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SiteHeader'),_c('keep-alive',[_c(_vm.dynamicComponent,_vm._b({tag:"component"},'component',_vm.currentProperties,false))],1),_vm._m(0),_c('SiteFooter',{attrs:{"makeupType":_vm.makeupType}}),_c('CookieConsent')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"backtotop"},[_c('div',{staticClass:"up-btn",attrs:{"id":"backTotop"}},[_vm._v("מעלה")])])])
}]

export { render, staticRenderFns }